import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../wayfinder'
import users from './users'
/**
* @see \App\Http\Controllers\AccountController::index
* @see app/Http/Controllers/AccountController.php:34
* @route '/accounts'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/accounts',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AccountController::index
* @see app/Http/Controllers/AccountController.php:34
* @route '/accounts'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AccountController::index
* @see app/Http/Controllers/AccountController.php:34
* @route '/accounts'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AccountController::index
* @see app/Http/Controllers/AccountController.php:34
* @route '/accounts'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AccountController::edit
* @see app/Http/Controllers/AccountController.php:72
* @route '/accounts/{account}/edit'
*/
export const edit = (args: { account: string | { id: string } } | [account: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/accounts/{account}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AccountController::edit
* @see app/Http/Controllers/AccountController.php:72
* @route '/accounts/{account}/edit'
*/
edit.url = (args: { account: string | { id: string } } | [account: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { account: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { account: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            account: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        account: typeof args.account === 'object'
        ? args.account.id
        : args.account,
    }

    return edit.definition.url
            .replace('{account}', parsedArgs.account.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AccountController::edit
* @see app/Http/Controllers/AccountController.php:72
* @route '/accounts/{account}/edit'
*/
edit.get = (args: { account: string | { id: string } } | [account: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AccountController::edit
* @see app/Http/Controllers/AccountController.php:72
* @route '/accounts/{account}/edit'
*/
edit.head = (args: { account: string | { id: string } } | [account: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AccountController::update
* @see app/Http/Controllers/AccountController.php:93
* @route '/accounts/{account}'
*/
export const update = (args: { account: string | { id: string } } | [account: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put","patch"],
    url: '/accounts/{account}',
} satisfies RouteDefinition<["put","patch"]>

/**
* @see \App\Http\Controllers\AccountController::update
* @see app/Http/Controllers/AccountController.php:93
* @route '/accounts/{account}'
*/
update.url = (args: { account: string | { id: string } } | [account: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { account: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { account: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            account: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        account: typeof args.account === 'object'
        ? args.account.id
        : args.account,
    }

    return update.definition.url
            .replace('{account}', parsedArgs.account.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AccountController::update
* @see app/Http/Controllers/AccountController.php:93
* @route '/accounts/{account}'
*/
update.put = (args: { account: string | { id: string } } | [account: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\AccountController::update
* @see app/Http/Controllers/AccountController.php:93
* @route '/accounts/{account}'
*/
update.patch = (args: { account: string | { id: string } } | [account: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\ToggleAccountActiveStateController::__invoke
* @see app/Http/Controllers/ToggleAccountActiveStateController.php:15
* @route '/accounts/{account}/toggle-active'
*/
export const toggleActive = (args: { account: string | { id: string } } | [account: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: toggleActive.url(args, options),
    method: 'put',
})

toggleActive.definition = {
    methods: ["put"],
    url: '/accounts/{account}/toggle-active',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\ToggleAccountActiveStateController::__invoke
* @see app/Http/Controllers/ToggleAccountActiveStateController.php:15
* @route '/accounts/{account}/toggle-active'
*/
toggleActive.url = (args: { account: string | { id: string } } | [account: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { account: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { account: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            account: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        account: typeof args.account === 'object'
        ? args.account.id
        : args.account,
    }

    return toggleActive.definition.url
            .replace('{account}', parsedArgs.account.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ToggleAccountActiveStateController::__invoke
* @see app/Http/Controllers/ToggleAccountActiveStateController.php:15
* @route '/accounts/{account}/toggle-active'
*/
toggleActive.put = (args: { account: string | { id: string } } | [account: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: toggleActive.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Account\BulkDetachUsersController::__invoke
* @see app/Http/Controllers/Account/BulkDetachUsersController.php:18
* @route '/accounts/{account}/bulk-detach-users'
*/
export const bulkDetachUsers = (args: { account: string | { id: string } } | [account: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: bulkDetachUsers.url(args, options),
    method: 'put',
})

bulkDetachUsers.definition = {
    methods: ["put"],
    url: '/accounts/{account}/bulk-detach-users',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Account\BulkDetachUsersController::__invoke
* @see app/Http/Controllers/Account/BulkDetachUsersController.php:18
* @route '/accounts/{account}/bulk-detach-users'
*/
bulkDetachUsers.url = (args: { account: string | { id: string } } | [account: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { account: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { account: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            account: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        account: typeof args.account === 'object'
        ? args.account.id
        : args.account,
    }

    return bulkDetachUsers.definition.url
            .replace('{account}', parsedArgs.account.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Account\BulkDetachUsersController::__invoke
* @see app/Http/Controllers/Account/BulkDetachUsersController.php:18
* @route '/accounts/{account}/bulk-detach-users'
*/
bulkDetachUsers.put = (args: { account: string | { id: string } } | [account: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: bulkDetachUsers.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Account\SecurityController::__invoke
* @see app/Http/Controllers/Account/SecurityController.php:15
* @route '/accounts/{account}/security'
*/
export const security = (args: { account: string | { id: string } } | [account: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: security.url(args, options),
    method: 'get',
})

security.definition = {
    methods: ["get","head"],
    url: '/accounts/{account}/security',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Account\SecurityController::__invoke
* @see app/Http/Controllers/Account/SecurityController.php:15
* @route '/accounts/{account}/security'
*/
security.url = (args: { account: string | { id: string } } | [account: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { account: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { account: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            account: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        account: typeof args.account === 'object'
        ? args.account.id
        : args.account,
    }

    return security.definition.url
            .replace('{account}', parsedArgs.account.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Account\SecurityController::__invoke
* @see app/Http/Controllers/Account/SecurityController.php:15
* @route '/accounts/{account}/security'
*/
security.get = (args: { account: string | { id: string } } | [account: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: security.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Account\SecurityController::__invoke
* @see app/Http/Controllers/Account/SecurityController.php:15
* @route '/accounts/{account}/security'
*/
security.head = (args: { account: string | { id: string } } | [account: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: security.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Account\TransferController::__invoke
* @see app/Http/Controllers/Account/TransferController.php:18
* @route '/accounts/{account}/transfer'
*/
export const transfer = (args: { account: string | { id: string } } | [account: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: transfer.url(args, options),
    method: 'get',
})

transfer.definition = {
    methods: ["get","head"],
    url: '/accounts/{account}/transfer',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Account\TransferController::__invoke
* @see app/Http/Controllers/Account/TransferController.php:18
* @route '/accounts/{account}/transfer'
*/
transfer.url = (args: { account: string | { id: string } } | [account: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { account: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { account: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            account: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        account: typeof args.account === 'object'
        ? args.account.id
        : args.account,
    }

    return transfer.definition.url
            .replace('{account}', parsedArgs.account.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Account\TransferController::__invoke
* @see app/Http/Controllers/Account/TransferController.php:18
* @route '/accounts/{account}/transfer'
*/
transfer.get = (args: { account: string | { id: string } } | [account: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: transfer.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Account\TransferController::__invoke
* @see app/Http/Controllers/Account/TransferController.php:18
* @route '/accounts/{account}/transfer'
*/
transfer.head = (args: { account: string | { id: string } } | [account: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: transfer.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Account\UpdateCompanyController::__invoke
* @see app/Http/Controllers/Account/UpdateCompanyController.php:23
* @route '/accounts/{account}/update-company'
*/
export const updateCompany = (args: { account: string | { id: string } } | [account: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: updateCompany.url(args, options),
    method: 'put',
})

updateCompany.definition = {
    methods: ["put"],
    url: '/accounts/{account}/update-company',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Account\UpdateCompanyController::__invoke
* @see app/Http/Controllers/Account/UpdateCompanyController.php:23
* @route '/accounts/{account}/update-company'
*/
updateCompany.url = (args: { account: string | { id: string } } | [account: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { account: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { account: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            account: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        account: typeof args.account === 'object'
        ? args.account.id
        : args.account,
    }

    return updateCompany.definition.url
            .replace('{account}', parsedArgs.account.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Account\UpdateCompanyController::__invoke
* @see app/Http/Controllers/Account/UpdateCompanyController.php:23
* @route '/accounts/{account}/update-company'
*/
updateCompany.put = (args: { account: string | { id: string } } | [account: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: updateCompany.url(args, options),
    method: 'put',
})

const accounts = {
    index: Object.assign(index, index),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    users: Object.assign(users, users),
    toggleActive: Object.assign(toggleActive, toggleActive),
    bulkDetachUsers: Object.assign(bulkDetachUsers, bulkDetachUsers),
    security: Object.assign(security, security),
    transfer: Object.assign(transfer, transfer),
    updateCompany: Object.assign(updateCompany, updateCompany),
}

export default accounts